import { render } from "./Assets.vue?vue&type=template&id=4461181a&ts=true"
import script from "./Assets.vue?vue&type=script&lang=ts"
export * from "./Assets.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__